'use strict';

var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var detectBrowser = require('../lib/detectBrowser.js');

var AnimationEasing = require('../lib/AnimationEasing.js');

function MobileMenu(config) {
	var self = this;
	
	this.config = config;

	this.initialSetup = false;
	this.menuActive = false;

	var browserInfo = detectBrowser.getInfo();
	this.animationUnsupported = browserInfo.android && browserInfo.androidInfo.versionBrowser == '4.0';
	
	this.$menu = $(config.menu);
	this.$menuTarget = this.$menu.find(config.menuTarget);
	
	$(window).on('ViewportTracker:state', function() {
		// Close menu on resize.
		self.toggleMenu(false);
		
		// Turn mobile menu on/off based on size
		if (ViewportTracker.getState() == 'mobile') {
			self.turnOn();
		} else {
			self.turnOff();
		}
	});
	
	
	// Disable clicking on items that open mega menus when on a mobile device so you can click to open
	var $openChildMenuLink = $('.node--L1.node--hasChild > a');
	$openChildMenuLink.on('mouseenter', function(e) {
		this._timeEnter = Date.now();
	});
	$openChildMenuLink.on('click', function(e) {
		if (this._timeEnter !== undefined && Date.now() - this._timeEnter < 40) {
			// More than likely a touch device
			e.preventDefault();
		}
	});
	$openChildMenuLink.on('blur mouseleave', function(e) {
		this._clickCount = undefined;
	});
}

MobileMenu.prototype.turnOn = function() {
	this.menuActive = true;
	
	if (this.initialSetup === false) {
		this.$menu.addClass(this.config.styleClass.setup);
		
		var self = this;
		
		// Open current and close the other ones
		var $nodeTriggers = this.$menu.find(this.config.nodeTrigger);
		this.openNode($nodeTriggers.not('.isActive').parent(), false);
		this.openNode($nodeTriggers.filter('.isActive').parent(), true);
		
		// Open/close menu handler
		$(this.config.triggers).on(this.config.triggerEvent, function(event) {
			if (self.menuActive === false)
				return;
			event.preventDefault();
			
			self.toggleMenu();
		});
		
		// Open/close node handler
		this.$menu.on('click.mobileMenu', this.config.nodeTrigger, function(event) {
			if (self.menuActive === false)
				return;
			event.preventDefault();
			
			var $anchor = event.target.tagName !== 'A' ? $(event.target).parent('A') : $(event.target);
			var $listItem = $anchor.parent('li');
			
			self.openNode($listItem, !self.isNodeOpen($listItem));
		});
		
		this.initialSetup = true;
	}
}

MobileMenu.prototype.turnOff = function() {
	this.menuActive = false;
}

MobileMenu.prototype.toggleMenu = function(forceOpen) {
	this.$menu.toggleClass(this.config.styleClass.menuOpen, forceOpen);
}

MobileMenu.prototype.isNodeOpen = function($listItem) {
	return $listItem.hasClass(this.config.styleClass.nodeOpen);
}
MobileMenu.prototype.openNode = function($listItem, open) {
	if (this.menuActive === false)
		return;
	
	if (this.config.onNodeChange !== undefined) {
		var ifContinue = this.config.onNodeChange($listItem, open);
		if (ifContinue === false) {
			return;
		}
	}
	
	if (this.config.hideSiblingMenuItems !== undefined) {
		if ($listItem.filter(this.config.hideSiblingMenuItems).length > 0) {
			this.slideToggle($listItem.siblings(this.config.hideSiblingMenuItems), this.config.collapsable.duration, AnimationEasing.easeOutExpo, !open);
		}
	}
	
	this.openNodeHelper($listItem, open);
}
MobileMenu.prototype.openNodeHelper = function($listItem, open) {
	$listItem.toggleClass(this.config.styleClass.nodeOpen, open);
	
	if (this.config.collapsable !== undefined) {
		var $elementSlide = $listItem.children('div'); 
		
		var duration = (this.animationUnsupported ? 0 : this.config.collapsable.duration);
		this.slideToggle($elementSlide, duration, AnimationEasing.easeOutExpo, open);
	}
}

MobileMenu.prototype.slideToggle = function($element, duration, ease, open) {
	$element.stop();
	if (open === true) {
		$element.slideDown(duration, ease);
	} else {
		$element.slideUp(duration, ease);
	}
}


module.exports = {
	MobileMenu : MobileMenu,
};
